import { render } from "./SMTP.vue?vue&type=template&id=4b58da9a"
import script from "./SMTP.vue?vue&type=script&lang=js"
export * from "./SMTP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__